angular.module("app").directive("tchLineSelector", ["ExploitationService", function (ExploitationService) {
	return {
		restrict: "E",
		templateUrl: "common/directives/exploitation/line/tchLineSelectorDirective.html",
		replace: true,
		scope: {
			data: "=tchLineSelectorData",
			callback: "&tchLineSelectorCallback",
			callbackAfterLoad: "&tchLineSelectorCallbackAfterLoad", // après le chargement des routes de la ligne sélectionnée ce callback est appelé
			useCache: "=tchLineSelectorCache",
			doNotFetch: "=tchLineSelectorDoNotFetch"
		},

		link: function (scope) {

			scope.lineSelected = function () {
            	scope.callback({line: scope.data.currentLine});
				if (!scope.doNotFetch) {
					if (scope.data.currentLine) {
						ExploitationService.getRoutes(scope.data.currentLine, scope.useCache !== undefined ? scope.useCache : false).then((response) => {
							const data = response.data;
							scope.data.routes = data;
							// Si la route sélectionné ne se trouve pas dans les routes a afficher on l'annule
							if (!data.some(r => r.id === scope.data.currentRoute)) {
								scope.data.currentRoute = undefined;
								scope.data.courses = {};
								scope.data.currentCourse = undefined;
							}
							if (scope.callbackAfterLoad) {
								scope.callbackAfterLoad();
							}
						});
					} else {
						scope.data.routes = {};
						scope.data.currentRoute = undefined;
					}
				}
			};

			/**
			 * A chaque changement de la ligne on doit recharger les routes
			 */
			scope.$watch("data.currentLine", (newValue, oldValue) => {
				if (scope.data.currentLine) {
					scope.lineSelected();
				}
				if (newValue !== oldValue) {
					scope.data.routes = {};
					scope.data.currentRoute = undefined;
				}
			});

		}
	};
}]);
